import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './radio.css';
import { createClasses } from '../helpers.js';

var Radio = function (_Component) {
	_inherits(Radio, _Component);

	function Radio() {
		_classCallCheck(this, Radio);

		return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	}

	_createClass(Radio, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    disabled = _props.disabled,
			    label = _props.label,
			    id = _props.id,
			    name = _props.name,
			    checked = _props.checked,
			    itemAction = _props.itemAction,
			    shopify_product_title = _props.shopify_product_title,
			    title = _props.title;

			var is_checked = checked || false;

			return React.createElement(
				'div',
				{ className: 'Radio' },
				React.createElement('input', {
					type: 'radio',
					id: id,
					disabled: disabled,
					name: name,
					checked: is_checked,
					value: label,
					onChange: function onChange(e) {
						itemAction(e.currentTarget.value, title, shopify_product_title);
					} }),
				React.createElement(
					'label',
					{ htmlFor: id },
					label
				)
			);
		}
	}]);

	return Radio;
}(Component);

export default Radio;